import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Auth } from '../services/auth';

export const companyGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const auth   = inject(Auth);
  const router = inject(Router);

  if (!auth.isLoggedIn()) {
    router.navigate(['/auth/company-login']);
    return false;
  }

  if (auth.getRole() !== 'COMPANY') {
    router.navigate(['/auth/company-login']);
    return false;
  }

  // Backend blocks every company-service request with a 403 while this is true (temp/first-login
  // password never rotated). The change-password screen only works right after the login/OTP flow
  // (it reuses the in-memory temp password as "current password" — there's no separate prompt for
  // it), so a session reached here via direct navigation/reload can't complete that screen anyway.
  // Clear the session and send them back to a fresh login rather than leaving CompanyLogin's own
  // ngOnInit redirect (isLoggedIn + role check, no must_reset_password check) bounce them straight
  // back here in a loop.
  if (localStorage.getItem('must_reset_password') === 'true') {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_role');
    localStorage.removeItem('must_reset_password');
    router.navigate(['/auth/company-login']);
    return false;
  }

  const profileComplete = localStorage.getItem('profile_complete') === 'true';
  const onCompleteProfilePage = state.url.includes('/complete-profile');

  if (!profileComplete && !onCompleteProfilePage) {
    router.navigate(['/company/complete-profile']);
    return false;
  }

  if (profileComplete && onCompleteProfilePage) {
    router.navigate(['/company/dashboard']);
    return false;
  }

  return true;
};
